<template lang="pug">
  form.buttons-container(@submit.prevent="updateStatus")
    notifications(group="action_msgs" position="top center")
    template(v-if="complaint.ecommerce === true")
      div
        action-button(v-if="complaint.aasm_state ==='pending_ecommerce'" variant="approved" actionId="refunded_ecommerce" text="Aceptar" :disabled="complaint.additional_infos.filter(info => info.source === 'internal' && info.name !== null).length === 0" ,@extra="extraComment")
        action-button(v-if="complaint.aasm_state ==='pending_ecommerce'" variant="reject-complaint" actionId="rejected_ecommerce" text="Rechazar" ,@extra="extraComment")
      div
        b-alert.m-1(show variant="info" v-if="complaint.aasm_state ==='pending_ecommerce' && complaint.additional_infos.filter(info => info.source === 'internal' && info.name !== null).length === 0 && (button_response.next === 'refunded_ecommerce' || button_response.next === undefined)") Para aceptar debe cargar el comprobante de reembolso en archivos adjuntos
    template(v-else)
      div(v-if="$isAllowed('viewAdmin')")
        action-button(variant="approved" actionId="closed" text="Aceptar" ,@extra="extraComment")
        action-button(variant="reject-complaint" actionId="rejected" text="Rechazar" ,@extra="extraComment")
      div(v-if="$isAllowed('viewCRM')")
        action-button(v-if="$isAllowed('requestInfo')" variant="primary" actionId="pending_requested" text="Solicitar información adicional" ,@extra="extraComment")
        action-button(v-if="$isAllowed('notifyRejection')" variant="primary" actionId="notified_rejection" text="Notificar rechazo" ,@extra="extraComment")
        action-button(v-if="$isAllowed('notifyApproval')" variant="primary" actionId="notified_approval" text="Notificar aprobación" ,@extra="extraComment")
        action-button(v-if="$isAllowed('resendERR')" variant="primary" actionId="pending_err" text="Confirmar ingreso de información" ,@extra="extraComment")
      div(v-if="$isAllowed('viewERR')")
        action-button(v-if="$isAllowed('sendToEDB')" variant="send-bus-operator" actionId="pending_edb" text="Enviar a la empresa de bus" ,@extra="extraComment")
        action-button(v-if="$isAllowed('makeInfoRequest')" variant="ask-information" actionId="pending_info" text="Pedir más información" ,@extra="extraComment")
        action-button(v-if="$isAllowed('approveReimbursement')" variant="approved" actionId="approved_reimbursement" text="Aprobado - Pendiente devolución" ,@extra="extraComment")
        action-button(v-if="$isAllowed('closeComplaint')" variant="approved" actionId="closed" text="Cerrar" ,@extra="extraComment")
        action-button(v-if="$isAllowed('rejectComplaint')" variant="reject-complaint" actionId="rejected_communication" text="Rechazar" ,@extra="extraComment")
      div(v-if="$isAllowed('viewFDP')")
        action-button(v-if="$isAllowed('reimburse')" variant="approved" actionId="closed" text="Devolución realizada" ,@extra="extraComment")
        action-button(v-if="$isAllowed('reimburse')" variant="reject-complaint" actionId="reimbursement_error" text="Error en transferencia" ,@extra="extraComment")
    b-form-group(v-if="button_response.code === 'approval'")
      h5 Detalles de la aprobación
      h6 Cliente: {{ customer_name }}
      label Compensación
        b-form-radio-group(:options="[{ text: 'Monetaria', value: 'm' }, { text: 'Otra', value: 'o' }]"
          v-model="action.reimbursement.compensation_type")
      div(v-if="action.reimbursement.compensation_type === 'm'")
        label.input-group Porcentaje:&nbsp;
          input(type="text" ,:value="action.reimbursement.percentage" ,@input="setComplaintPercentage($event)" ,:formatter="format")
          span.input-group-addon %
        label.input-group Monto:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          span.input-group-addon $
          input(type="text" ,:value="action.reimbursement.amount" ,@input="setComplaintAmount($event)")
        b-alert(show variant="danger" v-if="action.reimbursement.percentage > 200") El monto supera más que el doble del valor reclamado. Por favor ingresar el valor total en la casilla del monto, no del porcentaje. Si se necesita devolver más que el doble del monto reclamado, ingresar el reclamo manualmente a Canc_Admin.
        b-alert(show variant="danger" v-if="decimal_error") El monto en CLP no puede incluir decimales. Por favor ingresar un monto válido.
        b-alert(show variant="danger" v-if="percentage_error") La categoría "Suspensión / Paso cerrado" solo acepta hasta el 15% de devolución
      vue-editor(v-model="action.reimbursement.comment" id="customer-text" placeholder="Comentario",:editorToolbar="customToolbar")
      strong Opcional: Lo que se ingresa aquí se comunica al cliente
      b-form-group(label="Empresa de bus")
        strong {{ complaint.ticket_info.bus_operators[0] }}
      b-form-group(v-if="action.reimbursement.compensation_type === 'm'", label="Descontar de empresa de bus")
        b-form-radio-group(:options="[{ text: 'Sí', value: true }, { text: 'No', value: false }]"
        v-model="action.reimbursement.discount_from_company")
      b-form-group(v-if="action.reimbursement.discount_from_company")
        label.input-group Porcentaje&nbsp;&nbsp;
          input(type="text", v-model="action.reimbursement.discount_percentage" ,@input="setCompanyDiscountPercentage($event)" ,:formatter="format")
          span.input-group-addon %
        label.input-group Monto&nbsp;&nbsp;&nbsp;&nbsp;
          span.input-group-addon $
          input(type="text", v-model="action.reimbursement.discount" ,@input="setCompanyDiscount($event)")
    b-form-group(v-if="button_response.code === 'bus-operator'")
      h5 Detalles para la empresa de bus
      label Texto del cliente
        b-form-checkbox-group
          b-form-checkbox(@change="copyComplaintText" id="check-copy-complaint") Copiar del Reclamo
      vue-editor(v-model="activity.message" id="customer-text" ,:editorToolbar="customToolbar")
      strong
        small Obligatorio: este texto será visible para la empresa de bus.
      h6 Exigencia del cliente
      p {{ complaint.comment }}
    b-form-group(v-if="button_response.code === 'more-information'")
      h5 ¿Qué se necesita del cliente?
        vue-editor(v-model="activity.message" id="customer-text" ,:editorToolbar="customToolbar")
        small
          strong Obligatorio. Lo que se ingresa aquí, se comunica directamente al cliente.
    b-form-group(v-if="button_response.code === 'rejection'")
      h5 Detalles del rechazo
      label Razón del rechazo
      vue-editor(v-model="activity.message" id="customer-text" ,:editorToolbar="customToolbar")
      strong Obligatorio. Debe ser instrucción para el SAC. Lo que se ingresa aquí, NO se comunica al cliente sino solo internamente al SAC.
    b-form-group(v-if="button_response.code === 'rejection-message'")
      h5 Mensaje
        vue-editor(v-model="action.response.comment" id="customer-text" ,:editorToolbar="customToolbar")
        strong
          small Obligatorio
    b-form-group(v-if="button_response.code === 'approval-message'")
      h5 Mensaje
        vue-editor(v-model="action.response.comment" id="customer-text" ,:editorToolbar="customToolbar")
        strong
          small Obligatorio

    b-button(type="submit" variant="primary" class="positive-action btn-lg" v-show="button_response.code != undefined" v-if="action.reimbursement.percentage <= 200 && !decimal_error && !percentage_error") {{ text_cta }}
    b-alert(show variant="danger" v-if="action.reimbursement.percentage > 200") El monto de devolución no puede superar el doble del precio del ticket.
    b-alert(show variant="danger" v-if="decimal_error") El monto de devolución en CLP no puede incluir decimales.
    b-alert(show variant="danger" v-if="percentage_error") El porcentaje de devolución no puede ser mayor al 15%.
</template>

<script>
import kexaApi from '@/services/apiService';
import store from '@/store';
import actionsPerimeter from '@/perimeters/actionsPerimeter';
import actionButton from '@/components/layout/ActionButton';
import { VueEditor } from 'vue2-editor';

import * as fn from '@/utils/functions';

export default {
  name: 'actions',
  props: ['complaint'],
  components: {
    actionButton,
    VueEditor,
  },
  perimeters: [actionsPerimeter],
  data() {
    return {
      customer_name: this.$store.getters.selected.issuer_name,
      button_response: {},
      action: {
        response: {
          comment: null,
        },
        reimbursement: {
          amount: 0,
          percentage: 0,
          compensation_type: 'm',
          discount_from_company: false,
          discount: 0,
          discount_percentage: 0,
          comment: '',
        },
      },
      dialogOptions: {
        okText: 'Continuar',
        cancelText: 'Cancelar',
      },
      activity: {
        message: '',
        code: null,
      },
      compensation_type: '',
      complaint_price: 0,
      complaint_price_usd: 0,
      complaint_original_price: 0,
      complaint_price_percentage: 0,
      complaint_price_amount: 0,
      bus_operator_discount: false,
      bus_operator_discount_percentage: 0,
      bus_operator_discount_amount: 0,
      customer_information: '',
      text_cta: 'Proceder',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
        ],
      ],
      decimal_error: false,
      percentage_error: false,
    };
  },
  beforeMount() {
    this.setComplaintPrice();
  },
  mounted() {
    this.availableButtons();
  },
  computed: {
    lastMessage() {
      if ('internal_messages' in this.complaint) {
        return this.complaint.internal_messages.length;
      }
      return 0;
    },
  },
  methods: {
    availableButtons() {
      const children = this.$children;
      const complaintActions = document.querySelector('.complaint-actions');
      const complaintTitle = complaintActions.querySelector('h4');

      // There is always one element that makes it necessary to count from
      // one to get an accurate result
      if (children.length === 1) {
        complaintActions.classList.add('no-buttons');
        if (store.getters.selected.aasm_state === 'rejected' || store.getters.selected.aasm_state === 'closed') {
          complaintTitle.innerText = '✅ El reclamo está resuelto';
        } else {
          complaintTitle.innerText = 'No hay acciones disponibles para procesar el reclamo, ' +
            'ya que otro equipo es responsable de dar una instrucción. \nPor favor revise el estado del reclamo.';
        }
      }

      return children;
    },
    extraComment(e) {
      // TODO: Refactor. This function performs too many actions
      this.button_response = e;
      if (e.code === 'approval') {
        this.activity.code = 'complaint_approve';
        this.text_cta = 'Proceder';
      } else if (e.code === 'rejection') {
        this.activity.code = 'complaint_reject';
        this.text_cta = 'Confirmar rechazo';
      } else if (e.code === 'bus-operator') {
        this.activity.code = 'complaint_send_edb';
        this.text_cta = 'Reenviar a empresa';
      } else if (e.code === 'more-information') {
        this.activity.code = this.$sandbox.actions.getActivityAction();
        const opening = this.complaint.issuer_gender === 'male' ? 'Estimado' : 'Estimada';
        this.text_cta = (this.activity.code === 'complaint_err_request') ? 'Asignar a CRM' : 'Enviar mensaje al cliente';
        this.activity.message = (this.activity.code === 'complaint_err_request') ? '' : `${opening} ${this.complaint.issuer_name}<br><br><br>Atte.,<br>Recorrido.cl`;
      } else if (e.code === 'rejection-message') {
        this.activity.code = 'complaint_notify_rejection';
        this.text_cta = 'Enviar mensaje';
      } else if (e.code === 'approval-message') {
        this.activity.code = 'complaint_notify_approval';
        this.text_cta = 'Enviar mensaje';
      } else if (e.code === 'to-err') {
        this.activity.code = 'complaint_crm_info';
        this.text_cta = 'Proceder';
      } else {
        this.text_cta = 'Proceder';
      }
    },
    setComplaintPercentage(e) {
      this.action.reimbursement.percentage = e.target.value;
      if (this.complaint.complaint_category.number === 2 && this.action.reimbursement.percentage > 15) {
        this.percentage_error = true;
      } else {
        this.percentage_error = false;
      }
      if (this.complaint.ticket_info.sold_currency === 'CLP') {
        this.action.reimbursement.amount = ((e.target.value * this.complaint_price) / 100).toFixed();
      } else if (this.complaint.ticket_info.sold_currency === 'USD') {
        this.action.reimbursement.amount = ((e.target.value * this.complaint_price_usd) / 100).toFixed(2);
      } else {
        this.action.reimbursement.amount = ((e.target.value * this.complaint_price) / 100).toFixed(2);
      }

      this.action.reimbursement.amount_ioc = this.getReimbursementAmountIoc();
      this.action.reimbursement.amount_ibc = this.getReimbursementAmountIbc();
    },
    setComplaintAmount(e) {
      this.action.reimbursement.amount = e.target.value;
      if (this.complaint.ticket_info.sold_currency === 'CLP') {
        if (e.target.value !== 0 && e.target.value % 1 !== 0) {
          this.decimal_error = true;
        } else {
          this.decimal_error = false;
        }
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price)).toFixed();
      } else if (this.complaint.ticket_info.sold_currency === 'USD') {
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price_usd)).toFixed(2);
      } else {
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price)).toFixed(2);
      }

      this.action.reimbursement.amount_ioc = this.getReimbursementAmountIoc();
      this.action.reimbursement.amount_ibc = this.getReimbursementAmountIbc();
    },
    getComplaintPriceIoc() {
      return this.complaint.ticket_info.tickets_data.reduce((accumulator, object) => accumulator + object.final_price_ioc, 0);
    },
    getReimbursementAmountIoc() {
      const priceIoc = this.getComplaintPriceIoc();

      if (this.complaint.ticket_info.operator_currency === 'CLP') {
        return ((this.action.reimbursement.percentage * priceIoc) / 100).toFixed();
      }

      return ((this.action.reimbursement.percentage * priceIoc) / 100).toFixed(2);
    },
    getReimbursementAmountIbc() {
      const priceIoc = this.getComplaintPriceIoc();

      if (this.complaint.ticket_info.price_ibc !== '' || this.complaint.ticket_info.price_ibc !== null) {
        return ((this.action.reimbursement.percentage * this.complaint.ticket_info.price_ibc) / 100).toFixed();
      }

      return ((this.action.reimbursement.percentage * priceIoc) / 100).toFixed();
    },
    setCompanyDiscount(e) {
      this.action.reimbursement.discount = e.target.value;
      this.action.reimbursement.discount_percentage = (100 *
        (e.target.value / this.complaint_original_price)).toFixed(2);
    },
    setCompanyDiscountPercentage(e) {
      this.action.reimbursement.discount_percentage = e.target.value;
      this.action.reimbursement.discount = ((e.target.value * this.complaint_original_price) / 100)
        .toFixed(2);
    },
    setComplaintPrice() {
      this.complaint_price = this.complaint.ticket_info.price;
      this.complaint_original_price = this.complaint.ticket_info.original_price;
      this.complaint_price_usd = this.complaint.ticket_info.price_usd;
    },
    copyComplaintText() {
      const checkCopyComplaint = document.querySelector('#check-copy-complaint');

      if (checkCopyComplaint.checked) {
        this.activity.message = this.complaint.description;
      } else {
        this.activity.message = '';
      }
    },
    updateStatus() {
      if (this.button_response.code === 'approval' && this.action.reimbursement.compensation_type === 'm' && this.action.reimbursement.percentage === 0) {
        this.$notify({
          group: 'action_msgs',
          type: 'error',
          title: 'Error',
          text: 'Monto de devolución debe ser mayor a 0',
          duration: 3000,
        });
        return;
      }
      let valid = true;
      if (['approval-message', 'rejection-message'].includes(this.button_response.code) && this.action.response.comment === '') {
        valid = false;
      }
      if (['more-information', 'rejection'].includes(this.button_response.code) && this.activity.message === '') {
        valid = false;
      }
      const actionsWithMessages = ['more-information', 'rejection', 'bus-operator', 'approval-message', 'rejection-message', 'to-err'];
      const params = fn.filterParams(this.action, this.button_response.next);
      const $this = this;
      /* eslint-disable no-alert */
      if (valid) {
        this.$dialog.confirm('¿Estás seguro que deseas proceder?', this.dialogOptions)
          .then(() => {
            kexaApi.update(this.$route.params.complaint_id, {
              new_state: this.button_response.next,
              ...params,
            }).then(() => {
              if (actionsWithMessages.includes($this.button_response.code)) {
                $this.registerActivity();
              }
              $this.$parent.fetchComplaint();
              $this.button_response = {
                code: null,
                next: null,
              };
              $this.$emit('sendUpdate');
              $this.availableButtons();
              $this.clear();
              if (!this.complaint.ecommerce && !this.action.reimbursement.discount_from_company) {
                kexaApi.changeCouponState({
                  booking_token: $this.complaint.ticket_info.booking_number,
                  complaint_number: $this.complaint.number,
                }).then();
              }
            }).catch((res) => {
              if (res.status === 405) {
                this.$notify({
                  group: 'show_complaint',
                  type: 'error',
                  text: res.body.error ? res.body.error : 'No es posible actualizar este reclamo, porque ya está siendo procesado por una cancelación. Solo puede ser actualizado a Resuelto',
                  duration: 8000,
                });
              } else {
                $this.$notify({
                  group: 'action_msgs',
                  type: 'error',
                  title: 'Error',
                  text: 'base' in res.body ? res.body.base[0] : res.body,
                  duration: 8000,
                });
              }
            });
          }).catch(() => {});
      } else {
        $this.$notify({
          group: 'action_msgs',
          type: 'error',
          title: 'Error',
          text: 'Debe ingresar un mensaje',
          duration: 3000,
        });
      }
    },
    registerActivity() {
      kexaApi.register({
        complaint_id: this.$route.params.complaint_id,
        code: this.activity.code,
        message: this.activity.message,
      }).then(() => {
        this.activity.message = null;
      });
    },
    clear() {
      const buttons = document.querySelectorAll('.buttons-container .btn');
      buttons.forEach((currentButton) => {
        currentButton.classList.remove('btn-inactive');
      });
    },
    format(value) {
      const number = parseFloat(value);
      let output = 0;
      if (number > 100) {
        output = 100;
      } else if (number < 0) {
        output = 0;
      } else {
        output = number;
      }
      return output;
    },
  },
};
</script>

<style lang="scss">
  @import '../../assets/css/kexa-variables';

  .form-row label {
    width: 100%;
  }

  .btn-reject-complaint {
    background: {
      color: $rejected-red;
    }
  }
  .btn-ask-information {
    background: {
      color: $info-orange;
    }
  }
  .btn-send-bus-operator {
    background: {
      color: $send-bus-operator-purple;
    }
  }
  .btn-approved {
    background: {
      color: $approved-green;
    }
  }
  .buttons-container {
    div {
      .btn {
        padding: 6px 12px;
        margin: 5px;
        border-radius: 0;
        transition: .5s;
        &:hover {
          opacity: .9;
        }
        &.btn-inactive {
          opacity: .45;
        }
      }
    }
  }
  .complaint-actions {
    .positive-action {
      display: none;
    }
    &.has-active-option {
      .positive-action {
        display: block;
      }
    }
    &.no-buttons {
      h6 {
        display: none;
      }
    }
  }
  #customer-text {
    min-height: 250px;
  }
  .quillWrapper {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Actions.vue